import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { TakeawayServices } from '../../../takeaway/services';
import { OdsServices } from '../../../ods/services';
import { ConfigurationPaymentGetnetTerminalPage } from '../configuration-payment-getnet-terminal/configuration-payment-getnet-terminal';
import { ConfigurationPaymentGetnetTopPage } from '../configuration-payment-getnet-top/configuration-payment-getnet-top';

/**
 * Generated class for the OdsListViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-payments-getnet',
    templateUrl: 'configuration-payments-getnet.html',
})
export class ConfigurationPaymentsGetnetPage {

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public translate: TranslateService,
        public globals: Globals,
        public toastCtrl: ToastController,
        public odsServices: OdsServices,
        public takeawayServices: TakeawayServices) {
    }

    configGetnetTerminalPayment() {
        this.navCtrl.push(ConfigurationPaymentGetnetTerminalPage);
    }

    configGetnetTopPayment() {
        this.navCtrl.push(ConfigurationPaymentGetnetTopPage);
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payment-methods/configuration-payments-getnet/configuration-payments-getnet.ts